/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerAction, ApiCreateContainerActionRequest, ApiMarkContainerGroupRequest, ApiOrder, ApiPlanContainerRequest } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerActionsController.
 */
export class ContainerActionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /orders/{rootObjectId}/container_actions/{childId}:mark_for_booking
     */
    public markForBooking(childId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.post<Result<ApiContainerAction>, undefined>(`/orders/${rootObjectId}/container_actions/${childId}:mark_for_booking`, undefined);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions:mark_for_booking
     */
    public markGroupForBooking(request: ApiMarkContainerGroupRequest, rootObjectId: string): Promise<Result<ApiContainerAction[]>> {
        return this.http.post<Result<ApiContainerAction[]>, ApiMarkContainerGroupRequest>(`/orders/${rootObjectId}/container_actions:mark_for_booking`, request);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions:unmark_for_booking
     */
    public unmarkGroupForBooking(request: ApiMarkContainerGroupRequest, rootObjectId: string): Promise<Result<ApiContainerAction[]>> {
        return this.http.post<Result<ApiContainerAction[]>, ApiMarkContainerGroupRequest>(`/orders/${rootObjectId}/container_actions:unmark_for_booking`, request);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions:plan
     */
    public plan(request: ApiPlanContainerRequest, rootObjectId: string): Promise<Result<ApiOrder>> {
        return this.http.post<Result<ApiOrder>, ApiPlanContainerRequest>(`/orders/${rootObjectId}/container_actions:plan`, request);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions:prefill
     */
    public createPrefilled(request: ApiCreateContainerActionRequest | undefined, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.post<Result<ApiContainerAction>, ApiCreateContainerActionRequest | undefined>(`/orders/${rootObjectId}/container_actions:prefill`, request);
    }

    /**
     * Calls GET /orders/{rootObjectId}/container_actions:query
     */
    public getListGet(pageSize: number, pageNo: number, rootObjectId: string): Promise<Result<ListInfo<ApiContainerAction>>> {
        const query = new URLSearchParams();
        query.set('pageSize', `${pageSize}`);
        query.set('pageNo', `${pageNo}`);

        return this.http.get<Result<ListInfo<ApiContainerAction>>>(`/orders/${rootObjectId}/container_actions:query`, query);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions:query
     */
    public getListPost(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiContainerAction>>> {
        return this.http.post<Result<ListInfo<ApiContainerAction>>, ListRequest>(`/orders/${rootObjectId}/container_actions:query`, listRequest);
    }

    /**
     * Calls GET /orders/{rootObjectId}/container_actions/{childId}
     */
    public get(childId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.get<Result<ApiContainerAction>>(`/orders/${rootObjectId}/container_actions/${childId}`);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions
     */
    public add(childDto: ApiContainerAction, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.post<Result<ApiContainerAction>, ApiContainerAction>(`/orders/${rootObjectId}/container_actions`, childDto);
    }

    /**
     * Calls PUT /orders/{rootObjectId}/container_actions/{childId}
     */
    public put(childId: string, childDto: ApiContainerAction, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.put<Result<ApiContainerAction>, ApiContainerAction>(`/orders/${rootObjectId}/container_actions/${childId}`, childDto);
    }

    /**
     * Calls DELETE /orders/{rootObjectId}/container_actions/{childId}
     */
    public removeChild(childId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        return this.http.delete<Result<ApiContainerAction>>(`/orders/${rootObjectId}/container_actions/${childId}`);
    }
}
